export default "__VITE_ASSET__CNP0Qjf3__"